export function formatEmailDisplayName(value) {
  if (typeof value !== "string") {
    return "-";
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return "-";
  }

  const displayName = trimmedValue.includes("@")
    ? trimmedValue.split("@")[0]
    : trimmedValue;

  return displayName.replace(/\./g, " ").replace(/\s+/g, " ").trim() || "-";
}

export function formatEmailFirstName(value) {
  if (typeof value !== "string") {
    return "-";
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return "-";
  }

  const displayName = trimmedValue.includes("@")
    ? trimmedValue.split("@")[0]
    : trimmedValue;

  return displayName.split(".")[0].trim() || "-";
}
